<template>
    <el-card>
        <div class="course-content material-index is-always-shadow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    :label="$t('Staff.Modify.change_new')"
                    name="first"
                    :lazy="true">
                    <modify-phone />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import ModifyPhone from '@/components/widget/Staff/ModifyPhone';

export default {
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ModifyPhone,
    },
    data() {
        return {
            editableTabs: [
                {
                    name: 'first',
                    isShow: true,
                },
            ],
        };
    },
    mixins: [require('../../mixins/CacheQuery').default],
    methods: {
        handleClick(tab, event) {},
    },
};

</script>
